var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headed-container",class:{
    padded: _vm.padded,
  }},[_c('div',{staticClass:"hat",style:({
      backgroundColor: _vm.color,
    })},[_c('div',{staticClass:"title"},[_vm._t("header")],2),_c('div',{staticClass:"content"},[_vm._t("header-content")],2)]),_c('div',{staticClass:"inbody"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }